<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2112"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2116"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2126"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2124" /></clipPath></defs><g
     id="g2118"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2120"><g
         id="g2122"
         clip-path="url(#clipPath2126)"><g
           id="g2128"
           transform="translate(458.3398,175.1299)"><path
             d="M 0,0 C 2.77,-2.56 6.17,-4.44 9.97,-5.39 L 25.3,-9.23 c 4.03,-1.01 7.72,-3.09 10.66,-6.03 l 3.48,-3.48 c 6.74,-6.74 8.61,-16.94 4.7,-25.63 l -25.1,-55.82 -44.17,-5.5 -156.47,156.47 75.76,75.76 31.85,-31.86 18.28,-18.28 c 2.87,-2.87 4.93,-6.45 5.96,-10.37 l 4.26,-16.15 c 1.17,-4.45 3.61,-8.33 6.91,-11.27 3.29,-2.94 7.42,-4.93 11.98,-5.59 4.97,-0.72 9.42,-3.01 12.83,-6.37"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2130" /></g><g
           id="g2132"
           transform="translate(477.3804,74.9365)"><path
             d="M 0,0 -175.805,175.806"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2134" /></g><g
           id="g2136"
           transform="translate(167.9814,358.9146)"><path
             d="m 0,0 c -14.896,14.896 -14.896,39.046 0,53.942 14.896,14.896 39.047,14.896 53.942,0 C 68.838,39.046 68.838,14.896 53.942,0 39.047,-14.896 14.896,-14.896 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2138" /></g><g
           id="g2140"
           transform="translate(111.3901,312.269)"><path
             d="m 0,0 c -15.42,43.17 -5.54,93.35 29.62,127.56 47.41,46.11 123.96,45.32 170.44,-1.74 24.23,-24.52 35.85,-56.83 34.86,-88.81 l 13.49,-13.49 c 7.41,-7.41 7.41,-19.41 0.01,-26.81 l -90.38,-90.38 c -7.4,-7.4 -19.4,-7.4 -26.81,0.01 l -13.49,13.49 c -26.54,-0.82 -53.28,7.03 -75.62,23.55"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2142" /></g><g
           id="g2144"
           transform="translate(128.1099,228.3491)"><path
             d="m 0,0 c 16.06,6.4 27.41,22.09 27.41,40.43 0,24.03 -19.48,43.5 -43.51,43.5 -24.03,0 -43.51,-19.47 -43.51,-43.5 C -59.61,22.09 -48.26,6.4 -32.2,0 m 16.102,23.567 c -9.31,0 -16.857,7.548 -16.857,16.868 0,9.309 7.547,16.857 16.857,16.857 9.309,0 16.856,-7.548 16.856,-16.857 0,-9.32 -7.547,-16.868 -16.856,-16.868 z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2146" /></g><g
           id="g2148"
           transform="translate(41.7798,106.3901)"><path
             d="M 0,0 V 51.86"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2150" /></g><g
           id="g2152"
           transform="translate(182.2402,158.25)"><path
             d="m 0,0 v -102.86 c 0,-9.55 -7.74,-17.29 -17.29,-17.29 h -105.88 c -9.55,0 -17.29,7.74 -17.29,17.29 v 21"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2154" /></g><g
           id="g2156"
           transform="translate(192.1426,154.2139)"><path
             d="M 0,0 -80.131,32.759 -160.263,0 c -6.232,-2.548 -13.35,0.439 -15.898,6.671 l -7.572,18.521 c -2.548,6.233 0.439,13.35 6.671,15.898 l 88.531,36.193 c 5.384,2.201 11.416,2.201 16.799,0 L 16.799,41.09 c 6.232,-2.548 9.219,-9.665 6.671,-15.898 L 15.897,6.671 C 13.35,0.439 6.232,-2.548 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2158" /></g><path
           d="M 146.785,140.082 H 77.237 V 76.145 h 69.548 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path2160" /><g
           id="g2162"
           transform="translate(73.5278,295.5874)"><path
             d="m 0,0 c -0.187,0.187 -0.374,0.363 -0.56,0.55 -20.972,20.972 -20.972,54.975 0,75.948 l 27.265,27.265 c 5.65,5.64 12.233,9.766 19.262,12.378"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2164" /></g><g
           id="g2166"
           transform="translate(164.1602,408.3989)"><path
             d="M 0,0 C 4.31,-2.37 8.36,-5.39 12.02,-9.05 25.92,-22.95 30.61,-42.6 26.07,-60.36 23.78,-69.39 19.09,-77.94 12.02,-85 l -26.44,-26.44 -0.82,-0.82 c -6.35,-6.34 -13.86,-10.75 -21.86,-13.26 -0.08,-0.03 -0.16,-0.06 -0.25,-0.08 -1.33,-0.41 -2.67,-0.77 -4.02,-1.06 -3.9,-0.89 -7.87,-1.33 -11.85,-1.33 -3.4,0 -6.79,0.32 -10.13,0.97"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2168" /></g></g></g></g></svg>
</template>
